<div *ngIf="dataSource$ | async as dataSource" style="display: flex; flex-direction: column; height: 100%;">
  <div style="flex-grow: 1; display: flex; flex-direction: column; overflow: hidden;">
    <div style="padding: 0 35px; flex-grow: 1; overflow-y: auto;">
      <div style="padding: 0 35px; display: flex; justify-content: end; gap: 10px; position: sticky; top: 0; z-index: 1;">
        <button class="action-button" mat-button aria-label="Clear"
                *inRole="[roles.Administrator]"
                [disabled]="!selectedIds.length"
                matTooltip="Cancel Selected Workflows"
                (click)="cancelSelected()"
                style="transition: 350ms ease-in-out; background: #f44336; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fas fa-traffic-light-stop"></span>
          <span style="padding-left: 10px;">Cancel Selected</span>
        </button>
      </div>
      <div *ngIf="dataSource.data.length > 0" style="overflow: visible;">
        <table mat-table matSort [trackBy]="trackByFn" (matSortChange)="sort($event)" [dataSource]="dataSource" class="table-width"
               style="width: 100%; border-spacing: 0 3px; background: transparent;">
          <ng-container matColumnDef="selecto-checko">
            <th mat-header-cell *matHeaderCellDef style="width:1%">
              <div class="form-control-wrapper">
                <mat-checkbox
                  [indeterminate]="selectedIds.length > 0 && selectedIds.length < dataSource.data.length"
                  [checked]="selectedIds.length === dataSource.data.length"
                  (change)="selectAll($event.checked)"></mat-checkbox>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async">
              <div class="form-control-wrapper">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelected(element)"
                              [ngModel]="isSelected(element)"></mat-checkbox>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef style="width: 2%; font-size: 14px"></th>
            <td [ngClass]="{'active': element.executionState === 'Active'}" mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
              <div style="display: flex; gap: 12px; justify-content: flex-start; align-items: center;">
                <div class="status-icon-wrapper">
                  <div *ngIf="element.executionState === 'New'" class="fa-solid fa-sparkles success-icon" matTooltip="New: Workflow exists but a compiled state and context have not been built."></div>
                  <div *ngIf="element.executionState === 'Created'" class="fa-duotone fa-boxes-packing primary-icon" matTooltip="Created: Workflow has a compiled state and context but has not ran at least once."></div>
                  <div *ngIf="element.executionState === 'Started'" class="fa-duotone fa-rocket primary-icon" matTooltip="Started: Workflow has been invoked, but is not currently running or scheduled to run."></div>
                  <div *ngIf="element.executionState === 'Active'" class="success-icon loader"
                       matTooltip="Active: Workflow is currently being processed in the system. Attempts to schedule this workflow will fail while it is in an Active state."></div>
                  <div *ngIf="element.executionState === 'OnHold'" class="fa-regular fa-clock primary-icon"
                       matTooltip="OnHold: Workflow is currently being prevented from advancing due to the presence of a logic gate. When the workflow gate returns true, the status should return back to Started or Active."></div>
                  <div *ngIf="element.executionState === 'Complete'" class="fa-duotone fa-check-circle success-icon" matTooltip="Success: Workflow has been completed as expected and will not run again unless explicitly retried."></div>
                  <div *ngIf="element.executionState === 'Error'" class="fa-duotone fa-exclamation-circle critical-icon" matTooltip="Error: Workflow did not complete due to an error. Details will be in cloudwatch."></div>
                  <div *ngIf="element.executionState === 'Aborted'" class="fa-duotone fa-times-circle warn-icon" matTooltip="Aborted: Workflow did not complete due to failing the Validate step. Details will be in cloudwatch."></div>
					<div *ngIf="element.executionState === 'Pausing'"
						 class="fa-regular fa-pause success-icon"
						 matTooltip="Pausing: Workflow is in the process of pausing.">
					</div>
					<div *ngIf="element.executionState === 'Paused'"
						 class="fa-regular fa-pause success-icon"
						 matTooltip="Paused: Workflow execution has been paused.">
					</div>

                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="progressPercentage">
            <th mat-header-cell *matHeaderCellDef style="width: 12%; font-size: 14px" mat-sort-header="progressPercentage">Progress</th>
            <td [ngClass]="{'active': element.executionState === 'Active'}" mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
                style="font-size: 14px">
				<div style="display: flex; width: 100%; flex-direction: row; align-items: center; justify-content: space-between; gap: 10px;">
					<div style="display:flex; flex-grow: 1; height: 4px; background: black; border-radius: 30px;">
						@if (element.executionState === 'Active') {
							<div class="workflow-progress" [ngStyle]="{'width': element.progressPercentage + '%'}" style="height: 100%; border-radius: 30px;"></div>
						} @else {
							<div [ngStyle]="{'width': element.progressPercentage + '%'}" style="height: 100%; border-radius: 30px; background: gray;"></div>
						}
					</div>
					<div style="display: flex; gap:10px; flex-direction: row; align-items: center; justify-content: space-between;">
						<div>{{ element.progressPercentage | number: '1.0-0' }}% </div>
						<div *ngIf="element.createdAt | DateAgo:'short' as dateAgo">({{dateAgo}})</div>
					</div>
				</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 14px" mat-sort-header="id">Name</th>
            <td [ngClass]="{'active': element.executionState === 'Active'}" mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
                style="font-size: 14px" matTooltip="{{element.workflowKey}}"><span class="fal fa-copy" style="padding-right:10px; cursor: pointer;" (click)="copyTextToClipboard(element.workflowKey)"></span>{{ element.workflowName }} </td>
          </ng-container>
          <ng-container matColumnDef="caseName">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 14px" mat-sort-header="caseName">Case</th>
            <td [ngClass]="{'active': element.executionState === 'Active'}" mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
                style="font-size: 14px" matTooltip="{{element.caseId}}"><span class="fal fa-copy" style="padding-right:10px; cursor: pointer;" (click)="copyTextToClipboard(element.caseId)"></span> {{ element.caseName }} </td>
          </ng-container>
          <ng-container matColumnDef="currentOperation">
            <th mat-header-cell *matHeaderCellDef style="width: 25%;font-size: 14px" mat-sort-header="currentOperation">Step</th>
            <td [ngClass]="{'active': element.executionState === 'Active'}" mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async"
                style="font-size: 14px">{{ projectActiveStep(element) }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr [@rowTransitionAnimation]="{ value: '', params: { delay: i * 100 } }" mat-row *matRowDef="let row; let i = index; columns:columnsToDisplay" [style.height.px]="rowHeight$ | async"></tr>
        </table>
      </div>
      <div *ngIf="dataSource.data.length < 1">
        <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 450px; font-size: 20px;">
          <span class="fal fa-arrow-progress"></span>
          <span style="padding-left: 10px;">No workflows running at this time.</span>
        </div>
      </div>
    </div>
  </div>
</div>
